

































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { INode, IMergeValues } from '@lib-shared/editor/types';
import {
  CellType,
  EBlockWidth,
  EContext,
  ENodeType,
  ERowType,
} from '@lib-shared/editor/types/enums';
import EditorNodeDivider from '@/editor/editor-block-view/components/EditorNodeDivider.vue';
import EditorNodeText from '@/editor/editor-block-view/components/EditorNodeText.vue';
import EditorNodeTable from '@/editor/editor-block-view/components/EditorNodeTable.vue';
import EditorNodeImage from '@/editor/editor-block-view/components/EditorNodeImage.vue';
import EditorNodeForm from '@/editor/editor-block-view/components/EditorNodeForm.vue';
import EditorNodePricingTable from '@/editor/editor-block-view/components/pricing-table/EditorNodePricingTable.vue';
import { IRecipient } from '@lib-shared/types/Recipient';
import { IUser } from '@lib-shared/api/users/types/user';
import { IEditorRecipientInput } from '@lib-shared/types/editor-recipient-input';

@Component({
  components: {
    EditorNodeDivider,
    EditorNodeImage,
    EditorNodeTable,
    EditorNodeText,
    EditorNodeForm,
    EditorNodePricingTable,
  },
  data: () => ({
    EBlockWidth,
    ENodeType,
    ERowType,
  }),
})
export default class EditorCell extends Vue {
  @Prop({ default: () => EContext.Document }) context: EContext;
  @Prop() nodes: INode[];
  @Prop() mergeValues: IMergeValues;
  @Prop() isPdfViewer: boolean;
  @Prop() rowType: ERowType;
  @Prop() parentFirstChild: boolean;
  @Prop() parentLastChild: boolean;
  @Prop() blockWidthClass: EBlockWidth;
  @Prop() focusedRequiredId?: string;
  @Prop() cellWidth: number;
  @Prop() pageWidth: number;
  @Prop() isBlockToggled: boolean;
  @Prop() cellType: CellType;
  @Prop() isSigningSite: boolean;
  @Prop() sender: IUser;
  @Prop() recipient: IRecipient;
  @Prop() recipientInput!: IEditorRecipientInput[];

  filterNodes({ type }: INode) {
    switch (this.cellType) {
      case CellType.ImageAndText:
        return [ENodeType.Image, ENodeType.Text].includes(type);
      case CellType.ImageOnly:
        return ENodeType.Image === type;
      case CellType.TextOnly:
        return ENodeType.Text === type;
      default:
        return false;
    }
  }

  get filteredNodes() {
    return this.cellType ? this.nodes.filter(this.filterNodes) : this.nodes;
  }

  get isSmallScreen(): boolean {
    return (
      this.blockWidthClass === EBlockWidth.XXSmall || this.blockWidthClass === EBlockWidth.XSmall
    );
  }

  get widthStyle(): string {
    if (this.isSmallScreen) {
      return 'width: 100%;';
    } else if (this.rowType === ERowType.Columns) {
      return `width:calc(${this.cellWidth}% - 1rem)`;
    }
    return `width:${this.cellWidth}%`;
  }
}
